import React, { memo } from 'react';

import { Box, Link, Typography } from '@mui/material';
import FileUploadCDS from '@sharedCR/coreDesignSystem/FileUploadCDS';
import PropTypes from 'prop-types';

import {
  docChipIconStyles,
  docChipMetaStyles,
  docChipStyles,
  documentsListStyles,
  sectionStyles,
  sectionTitleStyles,
} from '../../DrawReviewDrawer.styles';
import { DrawReviewDrawerTestIds } from '../../DrawReviewDrawer.testIds';

const ACCEPTED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

const DrawDocumentsSection = ({ documents, selectedFile, errorMessage, onSelectFile, onError }) => (
  <Box data-testid={DrawReviewDrawerTestIds.DOCUMENTS_SECTION} sx={sectionStyles}>
    <Typography sx={sectionTitleStyles} variant="bold12">
      Documents
    </Typography>
    <FileUploadCDS
      acceptedFileTypes={ACCEPTED_FILE_TYPES}
      errorMessage={errorMessage}
      infoMessage="PDF, JPG or PNG · up to 25 MB"
      selectedFile={selectedFile}
      setErrorMessage={onError}
      setSelectedFile={onSelectFile}
    />
    <Box sx={documentsListStyles}>
      {documents.map(document => (
        <Box key={document.id} sx={docChipStyles}>
          <Box sx={docChipIconStyles}>
            <Typography variant="bold12">PDF</Typography>
          </Box>
          <Box sx={docChipMetaStyles}>
            <Typography variant="medium14">{document.name}</Typography>
            <Typography color="text.secondary" variant="regular12">
              {document.sizeLabel}
            </Typography>
          </Box>
          <Link
            data-testid={DrawReviewDrawerTestIds.DOCUMENT_VIEW_LINK}
            href={document.url}
            rel="noopener"
            target="_blank"
            underline="hover"
          >
            View
          </Link>
        </Box>
      ))}
    </Box>
  </Box>
);

DrawDocumentsSection.propTypes = {
  onSelectFile: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  documents: PropTypes.array,
  selectedFile: PropTypes.object,
  errorMessage: PropTypes.string,
};

export default memo(DrawDocumentsSection);
